import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { ClientDetailPageHeader, ClientDetailTable } from '@/components/pages/Client/Detail'
import routes from '@/constants/routes'
import useQueryPage from '@/hooks/useQueryPage'
import { useClient } from '@/pages/Client/Client.hooks'

const DeviceDetail = () => {
  const params = useParams<{ id: string }>()
  const [searchParams] = useSearchParams()
  const currentPage = useQueryPage()
  const navigate = useNavigate()
  const { deviceDetailResponse, loadingDetail, getDeviceDetail, page, pageSize, setPage } = useClient()
  const dataSource = deviceDetailResponse?.items ?? []
  const totalItems = deviceDetailResponse?.meta.totalItems || 0
  const deviceId = Number(params.id)
  const dateSearch = searchParams.get('date')

  const handleChangePage = (config: TablePaginationConfig) => {
    setPage(config.current ?? page)
    navigate({
      pathname: `${routes.clients.path}/${deviceId}`,
      search: `?page=${config.current ?? page}`,
    })
  }

  useEffect(() => {
    if (currentPage) {
      setPage(currentPage)
    }
  }, [currentPage, setPage])

  useEffect(() => {
    getDeviceDetail(deviceId, { date: dateSearch ? dateSearch : undefined })
  }, [dateSearch, deviceId, getDeviceDetail])

  return (
    <>
      <ClientDetailPageHeader />
      <ClientDetailTable {...{ dataSource, loadingDetail, page, totalItems, pageSize }} onChange={handleChangePage} />
    </>
  )
}

DeviceDetail.displayName = 'DeviceDetail'
export default DeviceDetail
